// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".explorers-status[data-v-1b11c023] .connection{display:flex;gap:5px;align-items:center}", ""]);
// Exports
module.exports = exports;
